import { t } from 'i18next';
import { PAYMENT_OPTIONS, PAYMENT_TYPE_OPTIONS } from '../constant/constants';

/**
 * Creates a formatter function that maps option IDs to translated labels.
 *
 * The formatter:
 * - converts the provided options into a lookup map
 * - translates option names using i18next
 * - returns an empty string for null/undefined values
 * - returns the original value if no matching option is found
 *
 * @param {OptionType[]} options - List of options containing ID and Name fields.
 *
 * @returns {(value: number | string | null | undefined) => string | number}
 * A formatter function that resolves IDs into translated labels.
 */

type OptionType = {
  ID: number | string;
  Name: string;
};

export const createFormatter = (options: OptionType[]) => {
  const map = new Map(options.map((opt) => [String(opt.ID), opt.Name]));

  return (value: number | string | null | undefined) => {
    if (value === null || value === undefined) return '';

    const translationKey = map.get(String(value));

    return translationKey ? t(translationKey) : String(value);
  };
};

/**
 * Formatter for payment device types.
 */
export const formatDeviceType = createFormatter(PAYMENT_OPTIONS);

/**
 * Formatter for payment types.
 */
export const formatPaymentType = createFormatter(PAYMENT_TYPE_OPTIONS);
